import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'
import { MerchantData } from './insertMerchant'

const getMerchantRequestBody = (merchantData: MerchantData) => {
  if (merchantData.mid === 'NP') {
    return {
      merchantId: merchantData.mid,
      vpa: merchantData.vpa,
    }
  }
  return {
    mobile: {
      number: merchantData.mobile,
      countryCode: '91',
    },
    merchantId: merchantData.mid,
    vpa: merchantData.vpa,
    terminalId: merchantData.terminalId,
  }
}

const createVpa = (merchantData: MerchantData, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.addMerchantVpa,
    body: getMerchantRequestBody(merchantData),
    method: 'POST',
  }
  return executeRequest(request)
    .then((data) => {
      if (data?.data?.status === 'SUCCESS') {
        return data?.data?.status
      } else {
        data.vpa = merchantData.vpa
        throw data
      }
    })
    .catch((err) => {
      err.vpa = merchantData.vpa
      throw err
    })
}

export { createVpa }
